import { createAction } from '@ngrx/store';

export const loadPage = createAction('[Lazy/base] load page');
